<template>
  <listheader v-if="listItems.length > 0"/>
  <listitem 
    @itemclicked="$emit('itemclicked',item)"
    :item="item" 
    v-for="item in listItems" 
    :key="item.ID"/>
  <slot></slot>
</template>

<script>
import listheader from './listheader.vue';
import listitem from './listitem.vue';
 
export default {
  props:["listItems"],
  emits:["itemclicked"],
  components:{
    listheader,
    listitem
  },
  setup () {
    

    return {}
  }
}
</script>

<style lang="scss" scoped>

</style>